import { Snackbar, Alert } from "@mui/material";

export default function Toast({open, duration, severity, onClose, message}){

    const position = {
        vertical: 'bottom',
        horizontal: 'center'
    }

    return <Snackbar open={open} autoHideDuration={duration || 5000} onClose={onClose} anchorOrigin={position}>
        {severity ? 
            <Alert 
                onClose={onClose} 
                severity={severity || 'info'} 
                sx={{width: '100%'}}
                variant='filled'
            >
                {message}
            </Alert> : 
            <span></span>
        }
    </Snackbar>
}